export default {
    'selectPage': {
        'login_user_name': '登录用户',
        'update_password': '修改密码',
        'logout': '退出登录',
        'center_text': '无忧达信息数字化管理中心',
        'container_center': '用户为先 · 拥抱变化 · 创新共赢 · 奋斗担当 · 自我批判 · 开放谦逊',
        // 原密码
        'old_password': '原密码',
        // 请输入原密码
        'old_password_placeholder': '请输入原密码',
        // 请输入密码
        'password_placeholder': '请输入密码',
        //密码格式不正确(须包含字母，数字,长度6-16位)
        'password_format_error': '密码格式不正确(须包含字母，数字,长度6-16位)',
        // 新密码
        'new_password': '新密码',
        // 请输入新密码
        'new_password_placeholder': '请输入新密码',
        // 再次输入新密码
        'new_password_again': '再次输入新密码',
        // 请再次输入新密码
        'new_password_again_placeholder': '请再次输入新密码',
        // 取消
        'btn_cancel': '取消',
        // 进入 OWMS
        'btn_enter_owms': '进入 OWMS',
        // 确定
        'btn_confirm': '确定',
        // 无忧达全球研发中心
        'wyd_global_development_center': '无忧达全球研发中心',
        // 您暂无权限登陆该系统
        'no_permission_login': '您暂无权限登陆该系统',
        //确定退出该系统吗?
        'logout_confirm': '确定退出该系统吗?',
        // 提示
        'tip': '提示',
        // 退出成功
        'logout_success': '退出成功',
        //选择仓库
        'select_warehouse': '选择仓库',
        // 新密码不能与旧密码相同
        'new_password_same_old_password': '新密码不能与旧密码相同',
        // 两次输入新密码不一致
        'new_password_not_same': '两次输入新密码不一致',
        // 修改密码成功
        'update_password_success': '修改密码成功',
        // 请选择
        'select_placeholder': '请选择',
    },
    login: {
        // 无忧达信息数字化管理中心
        'center_text': '无忧达信息数字化管理中心',
        // 用户为先 · 拥抱变化 · 创新共赢 · 奋斗担当 · 自我批判 · 开放谦逊
        'container_center': '用户为先 · 拥抱变化 · 创新共赢 · 奋斗担当 · 自我批判 · 开放谦逊',
        // 请输入用户名
        'username_placeholder': '请输入用户名',
        'username_message': '请输入用户名',

        // 请输入密码
        'password_placeholder': '请输入密码',
        'password_message': '请输入密码',

        // 记住密码
        'remember_password': '记住密码',
        // 登录
        'btn_login': '登录',
        // 请输入新密码
        'new_password_placeholder': '请输入新密码',
        // 再次输入新密码
        'new_password_again_placeholder': '请再次输入新密码',
        // 修改密码
        'btn_update_password': '修改密码',
        // 请输入手机号
        'phone_placeholder': '请输入手机号',
        // 获取验证码
        'get_valid_code': '获取验证码',
        // 请输入验证码
        'valid_code_placeholder': '请输入验证码',
        // 返回登录
        'btn_back_login': '返回登录',
        // 确认修改
        'btn_confirm_update_password': '确认修改',
        //密码格式不正确(须包含字母，数字,长度6-16位)
        'password_format_error': '密码格式不正确(须包含字母，数字,长度6-16位)',
        // 两次输入密码不一致
        'new_password_not_same': '两次输入密码不一致',
        // 手机号格式不正确
        'phone_format_error': '手机号格式不正确',
        // 登陆成功
        'login_success': '登陆成功',
        // 密码修改成功
        'update_password_success': '密码修改成功',
        // 手机号码有误
        'phone_error': '手机号码有误',
        // "发送成功！"
        'send_success': '发送成功！',
        // 该手机号暂未发送验证码
        'phone_not_send_code': '该手机号暂未发送验证码',
        // 修改成功
        'update_success': '修改成功',

    },
    common:{
        btn_confirm: '确认',
        btn_cancel: '取消',
    }
}
